export const MinimalWithdrawalValue = 5
export const WithdrawalMultiplier = 5

export const IntegrationStatuses = ['VALID', 'DISABLED'] as const
export type IntegrationStatus = (typeof IntegrationStatuses)[number]
